/* The tells a stylesheet cannot reach. v1.

   Companion to rockkt-type-v1.css, which does the typeface and the two pieces
   of decorative motion. This file is for the ones that are text rather than
   style, and so have to be edited in the DOM.

   ── THE RULE THIS FILE IS BUILT ON ──────────────────────────────────
   Only reach into the DOM for something that genuinely has no source to edit.

   Fixing copy at source and fixing it in the DOM are not equally good. The
   source version is in the served HTML, so a crawler and a slow connection
   both get it; the DOM version can flicker, and it is invisible to anything
   that does not run scripts. An earlier draft of this file rewrote several
   lines that turned out to live in files that CAN be edited - those all came
   out again and were fixed in the integrations template and
   rockkt-integrations-v2.js instead.

   What is left is the two that have nowhere else to go. Both live inside
   templates/index.liquid, which is 236KB - past what the Admin API will return
   or replace as text. Same route, and the same reason, as
   rockkt-footer-sync-v6.js.

   This file changes no layout and sets no styles. If it fails to load, the
   page is exactly as it was. */
(function () {

  /* ── 1. arrow glyphs welded to link text ──────────────────────────────
     "Get started →" is on every list of these tells, for the same reason the
     purple gradient is: it is what gets produced when nobody decided. A link
     already looks like a link. The arrow is there to make it feel like a call
     to action, and the effect is that it feels like a template.

     Only the glyph goes, not the words: "→ View in Tasks" becomes "View in
     Tasks". Matched on the character rather than the whole label so it keeps
     working if the wording around it is ever changed. */
  var ARROWS = /\s*[→➔➜»➡]\s*/g;

  function dearrow() {
    var links = document.querySelectorAll('a, button');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      /* Walk the link's own child text nodes rather than setting textContent.
         Setting textContent on a link would throw away any <svg> icon or
         <span> nested inside it, which is exactly how this sort of tidy-up
         usually breaks a button that happened to have an icon in it. */
      for (var j = 0; j < el.childNodes.length; j++) {
        var n = el.childNodes[j];
        if (n.nodeType !== 3) continue;
        ARROWS.lastIndex = 0;
        if (!ARROWS.test(n.nodeValue)) continue;
        ARROWS.lastIndex = 0;
        var next = n.nodeValue.replace(ARROWS, ' ').replace(/\s{2,}/g, ' ');
        /* Trim only at the ends of the label, so a glyph used BETWEEN two
           words leaves a space behind rather than welding them together. */
        if (j === 0) next = next.replace(/^\s+/, '');
        if (j === el.childNodes.length - 1) next = next.replace(/\s+$/, '');
        if (next !== n.nodeValue) n.nodeValue = next;
      }
    }
  }

  /* ── 2. the overclaim in the "One platform" section ──────────────────────
     The heading read "Everything sales & marketing need, in one place."
     Rockkt is not everything sales and marketing need - it does not do their
     CRM, their email or their ads - and Glen flagged it as a claim he did not
     want to make. "Everything a send needs" is the same sentence with the
     scope corrected to what the product actually covers.

     It is also, as written, generic-SaaS vocabulary: "everything X needs, in
     one place" is the cousin of "all-in-one platform" and reads as filler
     whichever way it is produced. A smaller claim that happens to be true is
     more persuasive than a large one that is not.

     WHY THIS IS HERE AND THE OTHER COPY FIXES ARE NOT. This heading is at
     byte 232,379 of templates/index.liquid. There is no source to edit. When
     that file is next rebuilt by hand, change it there and delete this entry.

     Exact-match on the old string, so the day the source IS corrected this
     quietly stops applying rather than mangling whatever replaced it. The
     ampersand is matched as a literal "&" because that is what textContent
     gives back, whatever the HTML entity was. */
  var REWRITES = [
    ['Everything sales & marketing need, in one place.',
     'Everything a send needs, in one place.']
  ];

  function recopy() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n, hits = [];
    while ((n = w.nextNode())) {
      for (var i = 0; i < REWRITES.length; i++) {
        if (n.nodeValue.indexOf(REWRITES[i][0]) > -1) hits.push([n, i]);
      }
    }
    /* Collected first, then written. Editing a text node while the walker is
       still traversing it invalidates the walker. */
    for (var k = 0; k < hits.length; k++) {
      hits[k][0].nodeValue =
        hits[k][0].nodeValue.replace(REWRITES[hits[k][1]][0], REWRITES[hits[k][1]][1]);
    }
  }

  function run() { dearrow(); recopy(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* The button band, the logo strip and the Features menu are all injected by
     deferred scripts, so a second pass after load catches anything that was
     not in the document the first time. Both functions are idempotent: a glyph
     already removed is not found again, and an exact-match rewrite does not
     match its own output. */
  window.addEventListener('load', function () { setTimeout(run, 400); });
})();
